module.exports = __webpack_public_path__ + "static/media/monthlyIncome.366ad327.svg";